// extracted by mini-css-extract-plugin
export default {"invoiceModalHolder":"l0NrsBGZByHKBXVjGQTS","amountTooltip":"SDA4YBmIP6q92cIjTMWw"};